/**
 * @generated SignedSource<<ba19bc34b65d22565025c02e12adae2c>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
type JobEventAcceptedExpired_event$fragmentType = any;
type JobEventAccepted_event$fragmentType = any;
type JobEventAgentDisconnected_event$fragmentType = any;
type JobEventAgentLost_event$fragmentType = any;
type JobEventAgentStopped_event$fragmentType = any;
type JobEventAssignedExpired_event$fragmentType = any;
type JobEventAssigned_event$fragmentType = any;
type JobEventBuildStepUploadCreated_event$fragmentType = any;
type JobEventCancelation_event$fragmentType = any;
type JobEventCanceled_event$fragmentType = any;
type JobEventChanged_event$fragmentType = any;
type JobEventCreated_job$fragmentType = any;
type JobEventExpired_event$fragmentType = any;
type JobEventFinished_event$fragmentType = any;
type JobEventJobLogSizeExceeded_event$fragmentType = any;
type JobEventLimited_event$fragmentType = any;
type JobEventRetried_event$fragmentType = any;
type JobEventScheduled_event$fragmentType = any;
type JobEventStarted_event$fragmentType = any;
type JobEventTimedOut_event$fragmentType = any;
export type JobEventType = "ACCEPTED" | "ACCEPTED_EXPIRED" | "AGENT_DISCONNECTED" | "AGENT_LOST" | "AGENT_STOPPED" | "ASSIGNED" | "ASSIGNED_EXPIRED" | "BUILD_STEP_UPLOAD_CREATED" | "CANCELATION" | "CANCELED" | "CHANGED" | "EXPIRED" | "FINISHED" | "LIMITED" | "LOG_SIZE_LIMIT_EXCEEDED" | "NOTIFICATION" | "RETRIED" | "SCHEDULED" | "STARTED" | "TIMED_OUT" | "UNBLOCKED" | "%future added value";
export type JobStates = "ACCEPTED" | "ASSIGNED" | "BLOCKED" | "BLOCKED_FAILED" | "BROKEN" | "CANCELED" | "CANCELING" | "EXPIRED" | "FINISHED" | "LIMITED" | "LIMITING" | "PENDING" | "RUNNING" | "SCHEDULED" | "SKIPPED" | "TIMED_OUT" | "TIMING_OUT" | "UNBLOCKED" | "UNBLOCKED_FAILED" | "WAITING" | "WAITING_FAILED" | "%future added value";
import type { FragmentType } from "relay-runtime";
declare export opaque type JobActivityTimelineList_job$fragmentType: FragmentType;
export type JobActivityTimelineList_job$data = {|
  +createdAt?: ?any,
  +events?: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: {|
        +timestamp: any,
        +type: JobEventType,
        +uuid: string,
        +$fragmentSpreads: JobEventAcceptedExpired_event$fragmentType & JobEventAccepted_event$fragmentType & JobEventAgentDisconnected_event$fragmentType & JobEventAgentLost_event$fragmentType & JobEventAgentStopped_event$fragmentType & JobEventAssignedExpired_event$fragmentType & JobEventAssigned_event$fragmentType & JobEventBuildStepUploadCreated_event$fragmentType & JobEventCancelation_event$fragmentType & JobEventCanceled_event$fragmentType & JobEventChanged_event$fragmentType & JobEventExpired_event$fragmentType & JobEventFinished_event$fragmentType & JobEventJobLogSizeExceeded_event$fragmentType & JobEventLimited_event$fragmentType & JobEventRetried_event$fragmentType & JobEventScheduled_event$fragmentType & JobEventStarted_event$fragmentType & JobEventTimedOut_event$fragmentType,
      |},
    |}>,
  |},
  +state?: JobStates,
  +uuid?: string,
  +$fragmentSpreads: JobEventCreated_job$fragmentType,
  +$fragmentType: JobActivityTimelineList_job$fragmentType,
|};
export type JobActivityTimelineList_job$key = {
  +$data?: JobActivityTimelineList_job$data,
  +$fragmentSpreads: JobActivityTimelineList_job$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobActivityTimelineList_job",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "state",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "JobEventCreated_job"
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 30
            }
          ],
          "concreteType": "JobEventConnection",
          "kind": "LinkedField",
          "name": "events",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "JobEventEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "timestamp",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "type",
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventLimited_event"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventFinished_event"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventRetried_event"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventScheduled_event"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventAssigned_event"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventAssignedExpired_event"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventCanceled_event"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventCancelation_event"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventAccepted_event"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventAcceptedExpired_event"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventStarted_event"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventTimedOut_event"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventChanged_event"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventBuildStepUploadCreated_event"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventExpired_event"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventAgentStopped_event"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventAgentDisconnected_event"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventAgentLost_event"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "JobEventJobLogSizeExceeded_event"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "events(first:30)"
        }
      ],
      "type": "JobTypeCommand",
      "abstractKey": null
    }
  ],
  "type": "Job",
  "abstractKey": "__isJob"
};
})();

(node/*: any*/).hash = "4f7a95216acc3bc1e2240eea6bc2b128";

module.exports = ((node/*: any*/)/*: Fragment<
  JobActivityTimelineList_job$fragmentType,
  JobActivityTimelineList_job$data,
>*/);
